<template>
    <div class="p-grid">
        <div class="p-col-12">
          <div class="card card-theme" id="chart-stack">
            <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
          </div>
        </div>
    </div>
</template>

<script>
  import UserService from '../../services/UserService';

  export default {
    name: "StackBar",
    props: {
      charts_data: {
        default: {}
      },
      user_accesses: {
        default: null
      }
    },
    data() {
      return {
          series: this.get_series(),
          chartOptions: {
            dataLabels: {
              enabled: true,
              formatter: function (e) {
                return "£" + e.toFixed(2)
              },
              style: {
                // colors: ["#444"]
                fontSize: "14px",
              }
            },
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: true
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0,
                }
              }
            }],
            plotOptions: {
              bar: {
                borderRadius: 8,
                horizontal: false,
              },
            },
            xaxis: {
              categories: this.charts_data.categories ? this.charts_data.categories : [],
              labels: {
                style: {
                  cssClass: 'custom-apexcharts-xaxis-label',
                }
              }
            },
            yaxis: {
              labels: {
                style: {
                  cssClass: 'custom-apexcharts-xaxis-label',
                }
              }
            },
            legend: {
              position: 'right',
              offsetY: 40,
              labels: {
                  colors: "#8e8e8e",
                  useSeriesColors: false
              },
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              x: {
                format: 'MM/dd/yyyy',
                formatter: undefined,
              },     
              y: {
                formatter: function(e) {
                  return "£" + e.toFixed(2)
                }
              }        
            }
          },
      }
    },
    methods: {
      get_series() {
        let userService = new UserService();
        if (this.user_accesses && userService.hasAccess(this.user_accesses, ['admin'])) {
          return [{
            name: this.charts_data.charity_total ? this.charts_data.charity_total.subtitle : "",
            data: this.charts_data.charity_total ? this.charts_data.charity_total.series : [],
          }, {
            name: this.charts_data.management_fee ? this.charts_data.management_fee.subtitle : "",
            data: this.charts_data.management_fee ? this.charts_data.management_fee.series : [],
          }, {
            name: this.charts_data.vat ? this.charts_data.vat.subtitle : "",
            data: this.charts_data.vat ? this.charts_data.vat.series : [],
          },]  
        } else {
          return [{
            name: this.charts_data.charity_total ? this.charts_data.charity_total.subtitle : "",
            data: this.charts_data.charity_total ? this.charts_data.charity_total.series : [],
          }, {
            name: this.charts_data.vat ? this.charts_data.vat.subtitle : "",
            data: this.charts_data.vat ? this.charts_data.vat.series : [],
          },] 
        }
  
      }
    }

  }
</script>

<style scoped lang="scss">

</style>
